import React, { useState, useContext } from "react";
import styled from "@emotion/styled";

// API
import PublicService from "../../../services/public.service";

// Context
import { StateContext } from "../../../common/context/StateContext";

// Components
import Typography from "../../../common/components/Typography";
import Input from "../../../common/components/Input";
import Button from "../../../common/components/Button";

// Form
import { useForm, Controller } from "react-hook-form";

//Mui
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

// Utils
import {
    PageGutter,
    ValidationMessages,
} from "../../../common/utils/constants";
import mediaQuery from "../../../common/utils/mediaQuery";
import { isValidEmail } from "../../../common/utils/validations";

// Images
import MailImg from "../../../images/icons/mail.svg";

const Container = styled.section`
    padding: ${PageGutter};
    background-color: white;
    position: relative;
    background-image: none;

    ${mediaQuery.tablet`
        background-image: url(${MailImg});
        background-repeat: no-repeat;
        background-size: 300px;
        background-position: right 50px center;
    `}
`;

const Newsletter = () => {
    const [isLoading, setIsLoading] = useState(false);
    const { setNotificationMessage } = useContext(StateContext);

    const { control, handleSubmit, reset } = useForm();

    const onSubmit = async (values) => {
        setIsLoading(true);

        const { status, code } = await PublicService.subscribeToNewsletter(
            values.email
        );
        if (status) {
            setNotificationMessage({
                message:
                    "You have been successfully subscribed to our newsletter",
                type: "success",
            });
            reset({});
        } else {
            if (code === 409) {
                setNotificationMessage({
                    message:
                        "Subscriber with this email address already exists.",
                    type: "error",
                });
            } else {
                setNotificationMessage({
                    message:
                        "We were unable to subscribe you to our newsletter. Please try again.",
                    type: "error",
                });
            }
        }
        setIsLoading(false);
    };

    return (
        <Container>
            <Typography variant="h4" sx={{ mb: 4 }}>
                Subscribe to our Newsletter
            </Typography>
            <Typography variant="paragraph" sx={{ mb: 4 }}>
                Receive the latest buzz on the tech block by subscribing to our
                monthly newsletter, The Bot Buzz. Stay up-to-date with the
                latest Resolute news, the latest trends in coding and robotics,
                and potential opportunities that are shaping our future. Don’t
                miss out on the buzz - subscribe today!
            </Typography>
            <Box sx={{ width: { sm: "100%", md: "40%" } }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Stack spacing={2}>
                        <Stack alignItems="center" direction="row" spacing={2}>
                            <Controller
                                name="email"
                                defaultValue=""
                                control={control}
                                rules={{
                                    required: "Required",
                                    validate: (value) =>
                                        isValidEmail(value) ||
                                        ValidationMessages.invalidEmail,
                                }}
                                render={({ field, fieldState: { error } }) => (
                                    <Input
                                        id="email"
                                        label="Email Address"
                                        error={error}
                                        {...field}
                                    />
                                )}
                            />
                            <Button
                                variant="contained"
                                disabled={isLoading}
                                type="submit"
                                isLoading={isLoading}
                                sx={{ py: "8px !important" }}
                            >
                                Subscribe
                            </Button>
                        </Stack>
                    </Stack>
                </form>
            </Box>
        </Container>
    );
};

export default Newsletter;
